export const ACCESS_TOKEN = "ACCESS_TOKEN";
export const REFRESH_TOKEN = "REFRESH_TOKEN";
export const ID_TOKEN = "ID_TOKEN";
export const LL_TOKEN = "longLivedToken";
export const USER_DETAILS = "userDetails";
export const REGEX = {
  phone: "^[+]?[(]?[0-9]{3}[)]?[-s.]?[0-9]{3}[-s.]?[0-9]{4,6}$",
  email: "^[a-zA-Z0-9-_]+(.[a-zA-Z0-9-_]+)*@[a-z0-9]+(-[a-z0-9]+)*(.[a-z0-9]+(-[a-z0-9]+)*)*.[a-z]{2,4}$",
};
